import React, { useState } from 'react';
import { connect } from 'umi';
import { TCategoryOptionsItem, ISingleCommonType } from '../../types';
import { useUpdateEffect } from 'ahooks';
import { SingleSelect, TSingleSelectType } from '../../components/SingleSelect';
import { singleMapStateToProps, singleMergeProps } from '../../connect/single';
import BubbleCommon from '@op/components/BubbleCommon';
import { useOnceTips } from '../../hooks/useFilterTips';
// import { filterCategoryTipsMap } from '@opm/components/BubbleCommon';
// import { timeRangeOptions } from '../../constant/timeRange';

export type CategorySelectType = Omit<TSingleSelectType, 'options'> & {
  channelFilterValue?: string;
  options: TCategoryOptionsItem[];
  filterOptions: (
    value: any,
    filterValue: any,
    channelFilterValue?: string,
  ) => TCategoryOptionsItem[];
};

export function CategorySelect({
  options,
  change,
  filterValue,
  value,
  filterOptions,
  channelFilterValue,
  ...props
}: CategorySelectType & ISingleCommonType) {
  const [realOptions, setRealOptions] = useState(
    filterOptions(options, filterValue, channelFilterValue),
  );

  const { showTips, openTips, closeTips } = useOnceTips();

  useUpdateEffect(() => {
    const list = filterOptions(options, filterValue, channelFilterValue);
    setRealOptions(list);

    const index = list.findIndex((item) => item.value === value);
    if (index === -1) {
      change(list[0]?.value);
      openTips();
    }
  }, [filterValue.time_range, filterValue.channels]);

  // const filterCategoryTips = useMemo(() => {
  //   const optionItem = timeRangeOptions.find(
  //     (item) => item.value === filterValue.time_range,
  //   );
  //   return filterCategoryTipsMap(optionItem, options?.[0]);
  // }, [filterValue]);

  return (
    <BubbleCommon
      showIcon={false}
      visible={showTips}
      tipsMap={undefined} // TODO: 先暂时注释
      placement="top"
      hasCloseIcon
      handleCloseIconClick={() => closeTips()}
    >
      <SingleSelect
        filterValue={filterValue}
        change={change}
        value={value}
        options={realOptions}
        {...props}
      ></SingleSelect>
    </BubbleCommon>
  );
}

export default connect(singleMapStateToProps, singleMergeProps)(CategorySelect);
